import { useState, useEffect } from 'react';
import { Row, Col, Button, Card, CardBody, CardHeader, Collapse } from 'reactstrap';
import { FaChevronUp, FaChevronDown } from 'react-icons/fa';
import uuid from 'react-uuid';
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Tooltip as ReactTooltip } from "react-tooltip";

const ItemTypeListViewForMap = ({ Section, itemTypesList, toggleItemTypeListState, handleClearSelection, handleItemClick, handleItemTypeListTogole, isWizardCompleted }) => {

    const [isOpen, setIsOpen] = useState(!isWizardCompleted);
    const [isIconUp, setIsIconUp] = useState(!isWizardCompleted);
    const [isCropping, setIsCropping] = useState(false);
    const [isWaterways, setIsWaterways] = useState(false); const [isIrrigation, setIsIrrigation] = useState(false);
    const [isLandErosion, setIsLandErosion] = useState(false);
    const [isOther, setIsOther] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
        handleItemTypeListTogole(!isOpen, !isIconUp);
    };
    useEffect(() => {
        if (Section == 'Cropping') {
            setIsCropping(true);
            setIsOther(false);
        }
        else if (Section == 'Land and Erosion') {
            setIsLandErosion(true);
            setIsOther(false);
        }
        else if (Section == 'WaterwaysRisk' || Section == 'WaterwaysMap') {
            setIsWaterways(true);
            setIsOther(false);
        }
        else if (Section == 'IrrigationRisk' || Section == 'IrrigationMap') {
            setIsIrrigation(true);
            setIsOther(false);
        }
    }, []);
    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yesItem";
    const showToastMessage = (e,message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };

    return (
        <Row>
            <Col>
                <div className="panel-group" id="accordion-Edit" role="tablist" aria-multiselectable="true">
                    {/*<Row>*/}
                    {/*    <Col>*/}
                    {/*        */}{/*<label className="outlineLabel para-light-sm ">Click Icon then Map to add</label>*/}
                    {/*        <Button style={{ float: "right", marginLeft: "auto", marginRight: "-5px" }} className="btnClearSelection float-end" color="warning" size="sm" onClick={handleClearSelection}>*/}
                    {/*            Clear Selection*/}
                    {/*        </Button>*/}
                    {/*    </Col>*/}
                    {/*</Row>*/}
                    {/*<br />*/}
                    <Row>
                        {itemTypesList.map(type =>
                            <Col key={uuid()} sm="12" className="style-item-display">
                                <Row>
                                    <Col sm="12">
                                        {isCropping &&
                                            <>
                                                <img
                                                    className="featureIcon"
                                                    src="/images/Icons/fwfp-icon-boundaries.png"
                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                /> <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>
                                            </>
                                        }
                                        {isIrrigation &&
                                            <>
                                                <img
                                                    className="featureIconNew"
                                                    src={"/images/ItemIcons/" + type.icon}
                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                />
                                                {type.name == 'Irrigation Area' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                {type.name == 'Irrigation Area' && type.markerType == 'rectangle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (square/rectangle)</label>}
                                                {type.name == 'Irrigation Area' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (freehand)</label>}
                                                {type.name != 'Irrigation Area' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                            </>
                                        }
                                        {isWaterways &&
                                            <>
                                                <img
                                                    className="featureIconNew"
                                                    src={"/images/ItemIcons/" + type.icon}
                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                />
                                                {type.name == 'Lake' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                {type.name == 'Lake' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (freehand)</label>}
                                                {type.name == 'Pond' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                {type.name == 'Pond' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (freehand)</label>}
                                                {type.name != 'Pond' && type.name != 'Lake' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                            </>
                                        }
                                        {isLandErosion &&
                                            <>
                                                <img
                                                    className="featureIconNew"
                                                    src={"/images/ItemIcons/" + type.icon}
                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                />
                                                {type.name == 'Areas that hold water' && type.markerType == 'circle' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (circle)</label>}
                                                {type.name == 'Areas that hold water' && type.markerType == 'polygon' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name} (freehand)</label>}
                                                {type.name != 'Areas that hold water' && <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>}
                                            </>
                                        }
                                        {isOther &&
                                            <>
                                                <img
                                                    className="featureIconNew"
                                                    src={"/images/ItemIcons/" + type.icon}
                                                    onClick={(event) => handleItemClick(event, type.id, type.markerType)}
                                                /> <label className="itemTypeStyle itemTypeStyleFont"> {type.name}</label>
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        )}
                    </Row>
                    <br />
                </div>
            </Col>
        </Row>
    )
}
export default ItemTypeListViewForMap